// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3cX1Z","label":"Section_label__1tM9d","contentWrap":"Section_contentWrap__2cl0x","footer":"Section_footer__Lu_C3","footerInner":"Section_footerInner__3_CVT"};